import { ref, Ref } from 'vue'
import { defineStore } from 'pinia'
import { generateUUID } from '@/utils/crypto'

export const useNotificationStore = defineStore('notification', () => {
  const notifications: Ref<NotificationItem[]> = ref([])
  const notifyReload = ref(false)

  function notifySuccess(message: string, persistent: boolean = false, callback = () => {}) {
    notifications.value.push({
      id: generateUUID(),
      message,
      callback,
      type: 'success',
      persistent,
      visible: true
    })
  }

  function notifyError(message: string, persistent: boolean = false, callback = () => {}) {
    notifications.value.push({
      id: generateUUID(),
      message,
      callback,
      type: 'alert',
      persistent,
      visible: true
    })
  }

  function notifyWarning(message: string, persistent: boolean = false, callback = () => {}) {
    notifications.value.push({
      id: generateUUID(),
      type: 'warning',
      message,
      persistent,
      visible: true,
      callback
    })
  }

  function notify(message: string, persistent: boolean = false, callback = () => {}) {
    notifications.value.push({
      id: generateUUID(),
      message,
      callback,
      type: 'message',
      persistent,
      visible: true
    })
  }

  function clearDisplayed() {
    notifications.value = notifications.value.filter((notification) => !notification.displayed)
  }

  function hide(id: string) {
    notifications.value.forEach((notification) => {
      if (notification.id == id) notification.visible = false
    })
  }

  return {
    notifications,
    notify,
    notifyError,
    notifySuccess,
    notifyWarning,
    clearDisplayed,
    hide,
    notifyReload
  }
})
